import React from 'react';
import { withStyles, Theme, createStyles, LinearProgress, Card, CardHeader, Button, TextField } from "@material-ui/core";
import { withRouter, RouteComponentProps } from "react-router-dom";
import  {SelfTimingEvent, EventEntryList} from '../models/Event';
import {withTranslation, WithTranslation} from 'react-i18next';
import SelfTimingBackend from "../providers/SelfTimingBackend";
import moment from 'moment';
import EditEventDetails from './EditEventDetails';

interface Props {
    Event : SelfTimingEvent;
    back : () => void;
  }

  interface State extends SelfTimingEvent {
    isLoading : boolean;
  }


class EditEventDetailsPage extends React.Component<Props & WithTranslation,State>
{
    constructor(props:Props & WithTranslation) {
        super(props);
        this.state = {
            Id : props.Event.Id,
            Classes : props.Event.Classes,
            Name : props.Event.Name,
            Organizer : props.Event.Organizer,
            Date : props.Event.Date,
            Description : props.Event.Description,
            EntryOpen:props.Event.EntryOpen,
            ShowPublic:props.Event.ShowPublic,
            isLoading:false
        };
    }
    onChange = (field : string, value : any) =>{
        let o = {} as any;
        o[field] = value;
        this.setState(o);        
    }
    save = () => {
        let back = new SelfTimingBackend();
        this.setState({isLoading : true});
        back.saveEvent({
            Id: this.props.Event.Id,
            Name: this.state.Name,
            Date: moment(this.state.Date).toDate(),
            Organizer: this.state.Organizer,
            Description: this.state.Description,
            Classes : this.props.Event.Classes,
            EntryOpen:this.state.EntryOpen,
            ShowPublic:this.state.ShowPublic
        }).then((res) => {
            this.setState({isLoading : false});
            this.props.back();
        });
    }
    render()
    {
        const { classes, t } = this.props as any;
        return <div>
            {this.state && this.state.isLoading &&
                <LinearProgress />
            }
            <EditEventDetails {...this.state} onChange={this.onChange}/>
            <div style={{marginTop:'5px'}}><Button onClick={this.save} variant="contained" color="primary">Spara</Button> <Button onClick={this.props.back} variant="contained" color="primary">Avbryt</Button>
            </div></div>

    }
}

const useStyles = ({ palette, spacing }: Theme) => createStyles({
  
    tableHeader: {
        backgroundColor: palette.primary.light,
        color: 'white'
    },
    formControl: {
        
        margin: '3px',
        minWidth: 200,
      },
      cardHeader: {
        backgroundColor: '#FFFFFF',
        color: '#000000'
      },
        cardHeaderTitle: {
            fontSize: '10px',
            lineHeight: '10px'
        }
  
});

export default withStyles(useStyles)(withTranslation()(EditEventDetailsPage));